import { Card, CardHeader, CardContent, Box, Typography, LinearProgress, Backdrop, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, Icon, IconButton } from "@mui/material";
import { from } from "rxjs";
import { ButtonIconType, StandardButton } from "../button/primary.button";
import { IHeaderButton } from "../../_common/interface/common/headerButton.interface";
import { PRIMARY_COLOR } from "../../_const/color.const";

/** Below this viewport width, label and value stack full-width; side-by-side at this width and up. */
const ROW_SIDE_BY_SIDE_MIN_PX = 960;

interface ICardHeaderButton extends IHeaderButton {
    icon: ButtonIconType,
    label?: string,
    shrink?: boolean
}

export interface StandardPanelParams {
    title: string;
    buttons?: Array<ICardHeaderButton>;
    loading: boolean;
    maxWidth?: number;
    children?: React.ReactNode;
}

export function StandardPanel(params: StandardPanelParams) {
    return (
        <Card
            elevation={3}
            sx={{
                display: "inline-block",
                width: "100%",
                maxWidth: params.maxWidth || "100%",
                breakInside: "avoid",
            }}
        >
            {params.loading && (<LinearProgress />)}

            <CardHeader title={params.title} action={
                <>
                    {(!!params.buttons && !!params.buttons.length) && params.buttons.map((m, index) => <>
                        {(m.label ? (
                            <StandardButton
                                shrink={m.shrink}
                                key={params.title + "button" + m.label}
                                disabled={m.disabled}
                                onClick={m.onClick} icon={m.icon}                         >
                                {m.label}
                            </StandardButton>
                        ) : (<IconButton
                            key={params.title + "button" + m.icon}
                            color={m.variant || "primary"}
                            disabled={m.disabled}
                            onClick={m.onClick}>
                            <Icon>{m.icon}</Icon>
                        </IconButton>))}


                    </>)}
                </>}
            />
            <CardContent sx={{ pt: 1 }}>{params.children}</CardContent>
        </Card>
    )
}

export function Row(params: {
    label: string;
    value: string | number | null | undefined;
}) {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            mb={2}
            gap={1}
            sx={{
                flexDirection: "column",
                flexWrap: "wrap",
                [`@media (min-width: ${ROW_SIDE_BY_SIDE_MIN_PX}px)`]: {
                    flexDirection: "row",
                },
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    width: "100%",
                    maxWidth: "100%",
                    fontWeight: 500,
                    color: "text.secondary",
                    [`@media (min-width: ${ROW_SIDE_BY_SIDE_MIN_PX}px)`]: {
                        width: 150,
                        flexShrink: 0,
                    },
                }}
            >
                {params.label}
            </Typography>

            <Typography
                variant="body2"
                sx={{
                    width: "100%",
                    flex: "none",
                    minWidth: 0,
                    color: "text.primary",
                    wordBreak: "break-word",
                    textAlign: "left",
                    [`@media (min-width: ${ROW_SIDE_BY_SIDE_MIN_PX}px)`]: {
                        width: "auto",
                        flex: 1,
                        textAlign: "right",
                    },
                }}
            >
                {params.value || "-"}
            </Typography>
        </Box>
    )
}


